export const SkillsList = [
    {
        key: 0,
        skill: "C/C++",
    },
    {
        key: 1,
        skill: "JavaScript",
    },
    {
        key: 2,
        skill: "Python",
    },
    {
        key: 3,
        skill: "Java",
    },
    {
        key: 4,
        skill: "React",
    },
    {
        key: 5,
        skill: "HTML",
    },
    {
        key: 6,
        skill: "CSS",
    },
    {
        key: 7,
        skill: "MySQL",
    },
    {
        key: 8,
        skill: "jQuery",
    },
    {
        key: 9,
        skill: "Firebase",
    },
    {
        key: 10,
        skill: "MongoDB",
    },
    {
        key: 11,
        skill: "ExpressJS",
    },
    {
        key: 12,
        skill: "NodeJS",
    },
    {
        key: 13,
        skill: "Spring Boot",
    },
    {
        key: 14,
        skill: "Kotlin",
    },
    {
        key: 15,
        skill: "JUnit",
    },
    {
        key: 16,
        skill: "Puppeteer",
    },
    {
        key: 17,
        skill: "TesseractJS",
    },
    {
        key: 18,
        skill: "Postman",
    },
    {
        key: 19,
        skill: "SQLite",
    },
    
];